'use strict';

/**
 * Controller class for the GridCol directive.
 */
export class GridColController {
    constructor(
        $scope,
        $signals,
        $timeout,
        $routeParams,
        SheetStructureHelperService,
        $uibModal,
        CMSSortableService,
        TaskCountdownService,
        CopyContainerHelperService,
        $element,
        CryptoHelperService,
        TaskDataService,
        $config,
        $bridges
    ) {
        // Assign dependencies
        this.$scope = $scope;
        this.$signals = $signals;
        this.$timeout = $timeout;
        this.$routeParams = $routeParams;
        this.SheetStructureHelperService = SheetStructureHelperService;
        this.$uibModal = $uibModal;
        this.CMSSortableService = CMSSortableService;
        this.TaskCountdownService = TaskCountdownService;
        this.CopyContainerHelperService = CopyContainerHelperService;
        this.$element = $element;
        this.CryptoHelperService = CryptoHelperService;
        this.TaskDataService = TaskDataService;
        this.$config = $config;
        this.$bridges = $bridges;

        // Initialize the controller
        this.initialize();
    }

    initialize() {
        const $scope = this.$scope;
        const $signals = this.$signals;
        const $timeout = this.$timeout;
        const $routeParams = this.$routeParams;
        const SheetStructureHelperService = this.SheetStructureHelperService;
        const TaskDataService = this.TaskDataService;
        const $config = this.$config;
        const $bridges = this.$bridges;
        const CMSSortableService = this.CMSSortableService;
        const CopyContainerHelperService = this.CopyContainerHelperService;
        const CryptoHelperService = this.CryptoHelperService;
        const TaskCountdownService = this.TaskCountdownService;
        const $element = this.$element;

        $scope.isCMS = isCMS;
        $scope.isPDFMode = $config.isPDFMode();
        $scope.isReady = true;

        $signals.on('removeOverlay', () => {
            $scope.isReady = true;
        });

        $signals.on('applyOverlay', () => {
            $scope.isReady = false;
        });

        // Init local variables
        this.taskContext = TaskDataService.fetchContext();
        const taskContext = this.taskContext;
        const config = {};
        const col = $scope.col;
        const partialUrlPrefix = $config.getTaskContentFolderPath();
        const sheet = taskContext.read($routeParams.sheetUUID);
        let containerData = null;
        let newContainer = false;
        let notificationDelete = false;
        let countObjects = [];
        let countObjectsCheck = 0;
        let newObjectsUUID = [];
        $scope.isJournal = sheet.isJournal();

        if ($scope.isJournal) {
            $scope.onContinueJournal = () => {
                $signals.emit('openJournalSaveModal');
            };
        }

        $scope.isUseQuestionParts = sheet.isUseQuestionParts();
        if ($scope.isCMS) {
            $scope.$signals = $signals;

            // Change Question-Part
            this.changeQuestionParts();

            $scope.initselect = (element) => {
                this.initselect(element);
            };
        }

        // Create New
        if (typeof col.content === 'object') {
            const new_uuid = angular.createUUID();
            col.content.uuid = new_uuid;
            taskContext.write(new_uuid, col.content);
            col.content = new_uuid;
            newContainer = col.content.showContainerCopy;
        }

        let contentObj = taskContext.read(col.content);

        if (contentObj === null) {
            const $logger = $bridges.logger();
            $logger.error('Invalid contentType found for ' + col.content);
        }

        if (contentObj.data.showContainerCopy) {
            navigator.clipboard
                .readText()
                .then((text) => {
                    console.log('CONTAINER INDEX ==>', contentObj.data.index);
                    notificationDelete = true;
                    text = JSON.parse(
                        CryptoHelperService.decrypt(
                            sessionStorage.copyContainerData.split('::')[0]
                        )
                    )[contentObj.data.index];
                    countObjects = text;
                    contentObj.data.showContainerCopy = false;

                    if (contentObj.isShowTabs()) {
                        $scope.tabs = {};
                        contentObj.data.tabs = [];

                        for (const key in text) {
                            $scope.contentObj.flagAsDirty();
                            const newObj = angular.copy(
                                CMSSortableService.getNewElements().tab.value[0]
                                    .content.tabs[0]
                            );
                            contentObj.data.tabs.push(newObj);
                            $signals.emit('rendering_rows', $scope.rows);
                        }

                        console.log('GET TABS ==>', contentObj.getTabs());
                        for (const tabIdx in contentObj.getTabs()) {
                            const tab = $scope.contentObj.getTabs()[tabIdx];
                            const tabsObjects = [];
                            if (typeof tab.content === 'object') {
                                const new_uuid = angular.createUUID();
                                tab.content.uuid = new_uuid;
                                taskContext.write(new_uuid, tab.content);
                                tab.content = new_uuid;
                            }

                            const tabObj = taskContext.read(tab.content);
                            tabObj.data.preferences = JSON.parse(
                                text[tabIdx].split('::')[2]
                            );
                            const tabObjectData = JSON.parse(
                                text[tabIdx].split('::')[3]
                            );
                            for (const tabObjKey1 in tabObjectData) {
                                tabsObjects.push(tabObjectData[tabObjKey1]);
                                console.log(
                                    'TAB OBJECTS ==>',
                                    tabObjectData[tabObjKey1]
                                );
                            }

                            for (const tabObjKey in tabsObjects) {
                                tabObj.data.objects[tabObjKey] =
                                    tabsObjects[tabObjKey];
                            }

                            angular.forEach(
                                tabObj.data.objects,
                                (value, key) => {
                                    if (typeof value === 'object') {
                                        console.log(
                                            'tabObj.data.objects  ==>',
                                            angular.toJson(tabObj.data.objects)
                                        );
                                        const new_uuid = angular.createUUID();
                                        tabObj.data.objects.splice(
                                            key,
                                            1,
                                            new_uuid
                                        );
                                        value.uuid = new_uuid;
                                        tabObj.data.objects[new_uuid] = value;
                                        tabObj.flagAsDirty();
                                        taskContext.write(new_uuid, value);
                                    }
                                }
                            );
                        }
                        setTimeout(() => {
                            CopyContainerHelperService.clearClipboard(
                                false,
                                false,
                                false
                            );
                        }, 800);
                    } else if (contentObj.isShowCarousels()) {
                        contentObj.data.carousels = [];

                        for (const key in text) {
                            $scope.contentObj.flagAsDirty();
                            const newObj = angular.copy(
                                CMSSortableService.getNewElements()
                                    .carousel.value[0].content.carousels[0]
                            );
                            contentObj.data.carousels.push(newObj);
                            $signals.emit('rendering_rows', $scope.rows);
                        }

                        for (const carouselIdx in contentObj.getCarousels()) {
                            const carousel =
                                $scope.contentObj.getCarousels()[carouselIdx];
                            const carouselObjects = [];

                            if (typeof carousel.content === 'object') {
                                const new_uuid = angular.createUUID();
                                carousel.content.uuid = new_uuid;
                                taskContext.write(new_uuid, carousel.content);
                                carousel.content = new_uuid;
                            }

                            const carouselObj = taskContext.read(
                                carousel.content
                            );
                            carouselObj.data.preferences = JSON.parse(
                                text[carouselIdx].split('::')[2]
                            );

                            const carouselObjectData = JSON.parse(
                                text[carouselIdx].split('::')[3]
                            );
                            for (const carouselObjKey1 in carouselObjectData) {
                                carouselObjects.push(
                                    carouselObjectData[carouselObjKey1]
                                );
                            }

                            for (const carouselObjKey in carouselObjects) {
                                console.log(
                                    'CONTENT TEXT ==>',
                                    carouselObjects[carouselObjKey]
                                );
                                carouselObj.data.objects[carouselObjKey] =
                                    carouselObjects[carouselObjKey];
                            }

                            angular.forEach(
                                carouselObj.data.objects,
                                (value, key) => {
                                    if (typeof value === 'object') {
                                        const new_uuid = angular.createUUID();
                                        carouselObj.data.objects.splice(
                                            key,
                                            1,
                                            new_uuid
                                        );
                                        value.uuid = new_uuid;
                                        carouselObj.data.objects[new_uuid] =
                                            value;
                                        carouselObj.flagAsDirty();
                                        taskContext.write(new_uuid, value);
                                    }
                                }
                            );
                        }
                        setTimeout(() => {
                            CopyContainerHelperService.clearClipboard(
                                false,
                                false,
                                false
                            );
                        }, 800);
                    } else if (contentObj.isShowIaaContainer()) {
                        contentObj.data.iaaContainer = [];

                        for (const key in text) {
                            $scope.contentObj.flagAsDirty();

                            const newObj = angular.copy(
                                CMSSortableService.getNewElements()
                                    .iaaContainer.value[0].content.iaaContainer[0]
                            );
                            newObj.content.preferences =
                                text[key].split('::')[2];
                            console.log('OB IAA ==>', newObj);

                            contentObj.data.iaaContainer.push(newObj);

                            $signals.emit('rendering_rows', $scope.rows);
                        }

                        for (const iaaIdx in contentObj.getIaaContainer()) {
                            const iaaContainer =
                                $scope.contentObj.getIaaContainer()[iaaIdx];
                            const iaaContainerObjects = [];

                            if (typeof iaaContainer.content === 'object') {
                                const new_uuid = angular.createUUID();

                                iaaContainer.content.uuid = new_uuid;
                                taskContext.write(
                                    new_uuid,
                                    iaaContainer.content
                                );
                                iaaContainer.content = new_uuid;
                            }

                            const iaaContainerObj = taskContext.read(
                                iaaContainer.content
                            );
                            iaaContainerObj.data.preferences = JSON.parse(
                                text[iaaIdx].split('::')[2]
                            );
                            iaaContainerObjects.push(
                                JSON.parse(text[iaaIdx].split('::')[3])
                            );

                            for (const iaaContainerObjKey in iaaContainerObjects) {
                                iaaContainerObj.data.objects[
                                    iaaContainerObjKey
                                ] = iaaContainerObjects[iaaContainerObjKey];
                            }

                            angular.forEach(
                                iaaContainerObj.data.objects,
                                (value, key) => {
                                    if (typeof value === 'object') {
                                        const new_uuid = angular.createUUID();
                                        iaaContainerObj.data.objects.splice(
                                            key,
                                            1,
                                            new_uuid
                                        );
                                        value.uuid = new_uuid;
                                        iaaContainerObj.data.objects[
                                            new_uuid
                                        ] = value;
                                        iaaContainerObj.flagAsDirty();
                                        taskContext.write(new_uuid, value);
                                    }
                                }
                            );
                        }
                        setTimeout(() => {
                            CopyContainerHelperService.clearClipboard(
                                false,
                                false,
                                false
                            );
                        }, 800);
                    } else {
                        const temp = [];
                        countObjectsCheck = 1;
                        newObjectsUUID = [];
                        console.log('NEW PASTE ==>', text);
                        for (const key in text) {
                            let object = contentObj.data.objects[key];
                            object = JSON.parse(text[key].split('::')[1]);
                            console.log(
                                'NEW  PASTE  PARSE==>',
                                JSON.parse(text[key].split('::')[2])
                            );

                            const arr = JSON.parse(text[key].split('::')[8])[0];

                            console.log(
                                'UNIVERSAL AGAIN ==>',
                                JSON.parse(text[key].split('::')[8])
                            );
                            if (
                                JSON.parse(text[key].split('::')[8]) !==
                                undefined
                            ) {
                                for (const parseKey in JSON.parse(
                                    text[key].split('::')[8]
                                )) {
                                    const palettesContent = angular.copy(
                                        JSON.parse(text[key].split('::')[8])
                                    );
                                    taskContext.write(
                                        parseKey,
                                        palettesContent[parseKey]
                                    );
                                }
                            }

                            const objects = contentObj.getObjects();
                            const new_uuid = angular.createUUID();
                            object.uuid = new_uuid;
                            contentObj.flagAsDirty();
                            contentObj.data.showContainerCopy = false;
                            contentObj.data.objects.splice(key, 1, new_uuid);
                            taskContext.write(new_uuid, object);
                            console.log('NEW UUID ==>', new_uuid);
                            newObjectsUUID.push(new_uuid);
                            $scope.hasContent = true;
                        }
                        setTimeout(() => {
                            CopyContainerHelperService.clearClipboard(
                                false,
                                false,
                                false
                            );
                        }, 800);
                    }
                })
                .catch((err) => {
                    console.log('Something went wrong', err);
                });
        }

        // Create New Object
        for (const key in contentObj.data.objects) {
            const object = contentObj.data.objects[key];

            if (!angular.isUUID(object)) {
                const new_uuid = angular.createUUID();
                object.uuid = new_uuid;
                taskContext.write(new_uuid, object);
                contentObj.flagAsDirty();
                contentObj.data.objects.splice(key, 1, new_uuid);
            }
        }

        $scope.contentObj = contentObj;

        // Detect CSS-class for content based on contentType
        const contentClassMap = {
            Container: 'material-box',
            Question: 'question-box',
            QuestionHeader: 'questionheader-box',
        };

        $scope.contentClass = contentClassMap[$scope.col.contentType];

        // Detect which "content config" is selected
        if (angular.isDefined(contentObj.getContentConfigurations)) {
            const contentConfigs = contentObj.getContentConfigurations();

            if (angular.isArray(contentConfigs) && contentConfigs.length > 0) {
                let cIdx =
                    angular.isDefined($scope.col.contentConfiguration) &&
                    angular.isNumber($scope.col.contentConfiguration)
                        ? $scope.col.contentConfiguration
                        : 0;

                if (cIdx > contentConfigs.length - 1) {
                    const $logger = $bridges.logger();
                    $logger.error(
                        'Invalid contentConfiguration #' +
                            cIdx +
                            ' specified for uuid ' +
                            contentObj.getUUID()
                    );
                    return;
                }
                const selectedContentConfig = contentConfigs[cIdx];

                for (const key in selectedContentConfig) {
                    if (selectedContentConfig.hasOwnProperty(key)) {
                        config[key] = selectedContentConfig[key];
                    }
                }
            }
        }

        // Determine question UUID
        $scope.questionPartUUID = null;
        $scope.questionPart = null;
        if ($scope.col.contentType === 'Question') {
            $scope.questionPartUUID = $scope.col.content;
            $scope.questionPart = taskContext.read($scope.questionPartUUID);
        } else if (
            $scope.col.contentType === 'Container' &&
            angular.isDefined(contentObj.getQuestionPart) &&
            contentObj.data.questionPart &&
            contentObj.getQuestionPart() !== null
        ) {
            $scope.questionPartUUID = contentObj.getQuestionPart().getUUID();
            $scope.questionPart = contentObj.getQuestionPart();
        }
        $scope.contentObj = contentObj;

        // Determine whether the title should be shown
        if ($scope.questionPartUUID !== null) {
            if ($scope.col.contentType === 'Material') {
                config.showTitle = false;
            } else if ($scope.col.contentType === 'QuestionHeader') {
                config.showTitle = true;
                delete config.partial;
            } else {
                config.showTitle =
                    typeof contentObj.data.showTitle === 'boolean'
                        ? contentObj.data.showTitle
                        : false;
            }
        } else {
            config.showTitle = false;
        }

        // Is this the right-hand-side column?
        config.rightCls = $scope.right === 1 ? 'right' : 'left';

        // Handle tabs and carousels
        config.showTabs =
            typeof contentObj.data.showTabs === 'boolean'
                ? contentObj.data.showTabs
                : false;
        config.showCarousels =
            typeof contentObj.data.showCarousels === 'boolean'
                ? contentObj.data.showCarousels
                : false;

        // Detect HTML partial to be loaded
        if (!angular.isDefined(config.partial)) {
            if (angular.isDefined($scope.col.partial)) {
                config.partial = partialUrlPrefix + $scope.col.partial;
            }
            if (angular.isDefined(contentObj.data.partial)) {
                config.partial = partialUrlPrefix + contentObj.data.partial;
            }
        } else if (angular.isDefined(config.partial)) {
            config.partial = partialUrlPrefix + config.partial;
        }

        // Handle objects
        if (angular.isFunction(contentObj.getObjects)) {
            config.objectRefs = contentObj.getObjects();
        } else {
            config.objectRefs = [];
        }

        $scope.config = config;

        $scope.debugId = 'gridCol_' + Math.random() * 100000;
        $scope.debugPanelCollapsed = true;

        const isQuestionHeader =
            $scope.col.contentType === 'QuestionHeader';

        $scope.isNoQuestionHeader = !isQuestionHeader;

        if (
            (typeof config.objectRefs !== 'undefined' &&
                config.objectRefs.length > 0) ||
            $scope.containerCopied
        ) {
            $scope.hasContent = !$scope.hasContent
                ? config.objectRefs.length > 0 ||
                  config.showTabs ||
                  config.partial ||
                  $scope.containerCopied
                : $scope.hasContent;
        }

        if (typeof $scope.contentObj.data === 'object' && typeof $scope.contentObj.data.questionPart === 'undefined') {
            $scope.contentObj.data.questionPart = null;
        }

        $scope.setBookMark = async () => {
            if (isCMS) return;

            try {
                const questionPart = $scope.contentObj.getQuestionPart();
                
                if (!questionPart) {
                    console.error('[Bookmark] No question part found in contentObj');
                    return;
                }

                const newBookmarkState = !questionPart.isBookmarked();
                const questionPartUUID = questionPart.getUUID();
                
                questionPart.setIsBookmarked(newBookmarkState);
                questionPart.save();
                
                const sheetUUID = $routeParams.sheetUUID;
                const sheet = taskContext.read(sheetUUID);
                
                if (!sheet) {
                    console.error('[Bookmark] Sheet not found for UUID:', sheetUUID);
                    return;
                }
                
                const allQuestionParts = sheet.getQuestionParts();
                const $rootElement = angular.element(document);

                const safeApply = (scope) => {
                    if (!scope) return;
                    const phase = scope.$root.$$phase;
                    if (phase !== '$apply' && phase !== '$digest') {
                        scope.$apply();
                    }
                };
                
                const updateSidebarBookmarks = () => {
                    const sidebarLinks = $rootElement[0].querySelectorAll('a[ng-repeat*="questionPart"]');
                    const scopesToUpdate = new Set();
                    
                    Array.from(sidebarLinks).forEach(linkElement => {
                        const elementScope = angular.element(linkElement).scope();
                        const partUUID = elementScope?.questionPart?.getUUID?.();
                        
                        if (partUUID !== questionPartUUID) return;
                        
                        if (newBookmarkState) {
                            linkElement.classList.add('bookmarked');
                        } else {
                            linkElement.classList.remove('bookmarked');
                        }
                        
                        const existingBookmarks = linkElement.querySelectorAll('.menu-bookmark');
                        existingBookmarks.forEach(bookmark => bookmark.remove());
                        
                        if (newBookmarkState) {
                            const bookmarkSpan = document.createElement('span');
                            bookmarkSpan.className = 'menu-bookmark';
                            linkElement.appendChild(bookmarkSpan);
                        }
                        
                        if (elementScope) {
                            scopesToUpdate.add(elementScope);
                        }
                    });
                    
                    scopesToUpdate.forEach(scope => safeApply(scope));
                };

                const updateSheetBookmark = () => {
                    const hasBookmarks = allQuestionParts.some(qp => qp.isBookmarked());
                    const sheetElement = $rootElement[0].querySelector(`.sheet-item-${sheetUUID}`);
                    if (!sheetElement) {
                        console.warn('[Bookmark] Sheet element not found:', sheetUUID);
                        return;
                    }
                    
                    const existingBookmarks = sheetElement.querySelectorAll('.menu-bookmark');
                    existingBookmarks.forEach(bookmark => bookmark.remove());
                    
                    if (hasBookmarks) {
                        const bookmarkSpan = document.createElement('span');
                        bookmarkSpan.className = 'menu-bookmark';
                        sheetElement.appendChild(bookmarkSpan);
                    }
                    
                    const elementScope = angular.element(sheetElement).scope();
                    safeApply(elementScope);
                };

                const updateHeadlineBookmarks = () => {
                    const questionHeadlines = $rootElement[0].querySelectorAll('question-headline');
                    const scopesToUpdate = new Set();
                    
                    questionHeadlines.forEach(headlineComponent => {
                        const questionUUID = headlineComponent.getAttribute('question');
                        
                        if (!questionUUID) {
                            console.warn('[Bookmark] Headline component without question attribute');
                            return;
                        }
                        
                        const currentQuestionPart = allQuestionParts.find(qp => qp.getUUID() === questionUUID);
                        
                        if (!currentQuestionPart) {
                            console.warn('[Bookmark] Question part not found for UUID:', questionUUID);
                            return;
                        }
                        
                        const h2Element = headlineComponent.querySelector('h2.question-headline');
                        if (!h2Element) {
                            console.warn('[Bookmark] No h2 element found in headline component');
                            return;
                        }
                        
                        const isBookmarked = currentQuestionPart.isBookmarked();
                        const existingBookmarks = h2Element.querySelectorAll('span.bookmarked');
                        existingBookmarks.forEach(bookmark => bookmark.remove());
                        
                        if (isBookmarked) {
                            const bookmarkSpan = document.createElement('span');
                            bookmarkSpan.className = 'bookmarked';
                            h2Element.appendChild(bookmarkSpan);
                        }
                        
                        const headlineScope = angular.element(headlineComponent).isolateScope();
                        if (headlineScope?.questionModel) {
                            headlineScope.questionModel.setIsBookmarked(isBookmarked);
                            scopesToUpdate.add(headlineScope);
                        }
                    });
                    scopesToUpdate.forEach(scope => safeApply(scope));
                };

                updateSidebarBookmarks();
                updateSheetBookmark();
                updateHeadlineBookmarks();

                safeApply($scope);

            } catch (error) {
                console.error('[Bookmark] Error in setBookMark:', error);
            }
        };

        $scope.isReadingTime = () => {
            return (
                TaskCountdownService.getInstance().getMode() ===
                    'readingTime' && !isCMS
            );
        };

        $scope.copyClipboard = () => {
            const cd = document.getElementById('copyCodeId');
            const string = cd.outerHTML;
            const hexEncoded = '';
            const binary = '';

            $scope.objectValue = CopyContainerHelperService.getObject();
            $scope.objectValue.data = hexEncoded;
            CopyContainerHelperService.setString(hexEncoded);
        };

        $scope.showOverlay = () => {
            $scope.isReady = false;
        };
    }

    changeQuestionParts() {
        const $scope = this.$scope;
        const $signals = this.$signals;
        const $timeout = this.$timeout;
        const $routeParams = this.$routeParams;
        const taskContext = this.taskContext;
        const col = $scope.col;
        let lastQuestionPartUUID;

        if (isCMS) {
            $timeout(() => {
                lastQuestionPartUUID = $scope.contentObj.data.questionPart;
            });
        }

        const _validateContentObjects = (container) => {
            if (!isCMS || !angular.isFunction(container.getObjects))
                return false;

            const objects = container.getObjects();
            for (const object_key in objects) {
                const object_uuid = objects[object_key];
                if (
                    angular.isUUID(object_uuid) &&
                    taskContext.exists(object_uuid)
                ) {
                    const object = taskContext.read(object_uuid);
                    object.validate(null);
                }
            }
        };

        const _validateSubContainer = (containers) => {
            if (!isCMS) return false;

            for (const key in containers) {
                const tmp = containers[key];
                if (
                    tmp &&
                    tmp.content &&
                    angular.isUUID(tmp.content) &&
                    taskContext.exists(tmp.content)
                ) {
                    const container = taskContext.read(tmp.content);
                    container.validate(null);
                    _validateContentObjects(container);
                }
            }
        };

        const _validateContainer = (container) => {
            if (!isCMS) return false;

            if (
                angular.isFunction(container.isShowTabs) &&
                container.isShowTabs()
            ) {
                const tabs = container.getTabs();
                _validateSubContainer(tabs);
            } else if (
                angular.isFunction(container.isShowCarousels) &&
                container.isShowCarousels()
            ) {
                const carousels = container.getCarousels();
                _validateSubContainer(carousels);
            } else if (
                angular.isFunction(container.isShowIaaContainer) &&
                container.isShowIaaContainer()
            ) {
                const iaaContainers = container.getIaaContainer();
                _validateSubContainer(iaaContainers);
            } else {
                container.validate(null);
                _validateContentObjects(container);
            }
        };

        $scope.changeQuestionPart = () => {
            if ($scope.contentObj.data.questionPart === 'empty') {
                delete $scope.contentObj.data.questionPart;
            }
            $scope.contentObj.flagAsDirty();
            $signals.emit('rendering_rows', $scope.rows);

            if (isCMS) {
                $timeout(() => {
                    if (
                        angular.isUUID(lastQuestionPartUUID) &&
                        lastQuestionPartUUID !==
                            $scope.contentObj.data.questionPart &&
                        taskContext.exists(lastQuestionPartUUID)
                    ) {
                        const lastQuestionPartObj = taskContext.read(
                            lastQuestionPartUUID
                        );
                        lastQuestionPartObj.validate(null);
                    }
                    _validateContainer($scope.contentObj);
                });
            }
        };

        const checknext = (object, position, key, step) => {
            const nextKey_1_step =
                Object.keys($scope.headlines)[position + key];
            if (
                $scope.headlines[nextKey_1_step] &&
                $scope.headlines[nextKey_1_step].value.questionPart.data.uuid ===
                    $scope.questionParts[object.id].index
            ) {
                if (step && step !== key) {
                    return checknext(object, position, key++, step);
                }
                return true;
            } else {
                return false;
            }
        };

        $scope.select2Options = {
            width: '300px',
            dropdownCssClass: 'drop-down-question-part-list',
            formatResult: (object, container, query) => {
                if (typeof $scope.questionParts[object.id] !== 'undefined') {
                    let color = 'red';
                    let info = '';

                    if (
                        typeof $scope.usedHeadlines[
                            $scope.questionParts[object.id].index
                        ] === 'undefined'
                    ) {
                        color = 'green';
                    }

                    let position = 0;
                    angular.forEach($scope.headlines, (value, key) => {
                        if (
                            value.questionPart.data.uuid ===
                                $scope.contentObj.data.questionPart &&
                            value.contentUUID === col.content
                        ) {
                            position = key;
                        }
                    });

                    let error = false;

                    if (
                        $scope.headlines[parseInt(position) + 1] &&
                        $scope.headlines[parseInt(position) + 1].questionPart
                            .data.uuid === $scope.questionParts[object.id].index
                    ) {
                        color = 'green';
                    }

                    if (
                        $scope.headlines[parseInt(position) - 1] &&
                        $scope.headlines[parseInt(position) - 1].questionPart
                            .data.uuid === $scope.questionParts[object.id].index
                    ) {
                        color = 'green';
                    }

                    if (
                        !error &&
                        $scope.headlines[parseInt(position) - 1] &&
                        $scope.headlines[parseInt(position) + 1] &&
                        $scope.headlines[parseInt(position)].questionPart.data
                            .uuid !==
                            $scope.headlines[parseInt(position) - 1].questionPart
                                .data.uuid &&
                        $scope.headlines[parseInt(position) + 1].questionPart
                            .data.uuid ===
                            $scope.headlines[parseInt(position) - 1].questionPart
                                .data.uuid &&
                        $scope.headlines[parseInt(position) - 1].questionPart
                            .data.uuid !== $scope.questionParts[object.id].index
                    ) {
                        color = 'red';
                        error = true;
                    }
                    if (
                        !error &&
                        $scope.headlines[parseInt(position)] &&
                        $scope.headlines[parseInt(position)].colPosition === 1 &&
                        $scope.headlines[parseInt(position) + 1] &&
                        $scope.headlines[parseInt(position) + 1].questionPart
                            .data.uuid ===
                            $scope.headlines[parseInt(position)].questionPart
                                .data.uuid &&
                        $scope.headlines[parseInt(position) + 2] &&
                        $scope.headlines[parseInt(position) + 2].questionPart
                            .data.uuid ===
                            $scope.headlines[parseInt(position)].questionPart
                                .data.uuid
                    ) {
                        color = 'red';
                        error = true;
                    }
                    if (
                        !error &&
                        $scope.headlines[parseInt(position) - 1] &&
                        $scope.headlines[parseInt(position) - 1]
                            .equalHeadlineCounter > 1 &&
                        $scope.headlines[parseInt(position) + 1] &&
                        $scope.headlines[parseInt(position)].rowKey ===
                            $scope.headlines[parseInt(position) + 1].rowKey &&
                        $scope.headlines[parseInt(position) + 1].colPosition ===
                            2 &&
                        $scope.headlines[parseInt(position) + 1].questionPart
                            .data.uuid !== $scope.questionParts[object.id].index
                    ) {
                        if (
                            typeof $scope.usedHeadlines[
                                $scope.questionParts[object.id].index
                            ] !== 'undefined'
                        ) {
                            color = 'red';
                            error = true;
                        }
                    }
                    if (
                        !error &&
                        $scope.headlines[parseInt(position) - 1] &&
                        $scope.headlines[parseInt(position) + 1] &&
                        $scope.headlines[parseInt(position) - 1].questionPart
                            .data.uuid === $scope.contentObj.data.questionPart &&
                        ($scope.headlines[parseInt(position) + 1].questionPart
                            .data.uuid ===
                            $scope.contentObj.data.questionPart ||
                            ($scope.headlines[parseInt(position)].rowKey ===
                                $scope.headlines[parseInt(position) - 1].rowKey &&
                                $scope.headlines[parseInt(position)]
                                    .colPosition === 2))
                    ) {
                        color = 'red';
                        error = true;
                    }

                    if (
                        $scope.contentObj.data.questionPart ===
                        $scope.questionParts[object.id].index
                    ) {
                        color = 'blue';
                    }
                    return `<div style="color:${color};" >${object.text}${info}</div>`;
                } else {
                    return object.text;
                }
            },
        };
    }

    initselect(element) {
        const $timeout = this.$timeout;
        const SheetStructureHelperService = this.SheetStructureHelperService;
        const taskContext = this.taskContext;
        const $routeParams = this.$routeParams;

        $timeout(() => {
            $('.' + element).trigger('change');

            $('.' + element).on('select2-open', function (e) {
                $('.add-new-question-part').off('click');
                $('#select2-drop')
                    .find('.add-new-question-part')
                    .on('click', function () {
                        $('.' + element).select2('close');
                        const sheet = taskContext.read(
                            $routeParams.sheetUUID
                        );
                        SheetStructureHelperService.openEditQuestionPartsModal(
                            'sheetStructureEditor',
                            sheet
                        );
                        $('.add-new-question-part').off('click');
                    });
            });

            if (
                $('.' + element)
                    .find('.drop-down-question-part-list')
                    .find('.add-new-question-part').length === 0
            ) {
                const html =
                    '<div class="add-new-question-part glyphicon glyphicon-th-list" ng-disabled="deactiveCreateSheetModalBtn">' +
                    '<span>Add new Question-Parts</span>' +
                    '</div>';
                $('.' + element)
                    .find('.drop-down-question-part-list')
                    .append('<hr>' + html + '');
            }
        }, 1000);
    }
}

/**
 * Registers the GridCol directive with the provided AngularJS module.
 * @param {angular.IModule} module - The AngularJS module to register the directive with.
 */
export default function registerGridColDirective(module) {
    module.directive('asfGridCol', [
        '$rootScope',
        '$compile',
        '$bridges',
        'TaskDataService',
        '$templateCache',
        '$http',
        '$config',
        '$signals',
        '$timeout',
        '$routeParams',
        '$sce',
        function (
            $rootScope,
            $compile,
            $bridges,
            TaskDataService,
            $templateCache,
            $http,
            $config,
            $signals,
            $timeout,
            $routeParams,
            $sce
        ) {
            return {
                restrict: 'EA',
                replace: false,
                scope: {
                    /* UI-Sortable */
                    sortableOption: '=',
                    connectWith: '=',
                    /* Headlines/Question-Parts */
                    questionParts: '=',
                    colHeadlinesMessage: '=',
                    colHeadlines: '=',
                    usedHeadlines: '=',
                    headlines: '=',
                    /* Rows */
                    rows: '=',
                    rowKey: '=',
                    containerKey: '=',
                    colKey: '=',
                    /* Col */
                    col: '=',
                    colmodel: '=',
                    right: '=',
                    size: '=',
                    layout: '=',
                    activeTab: '=',
                    activeCarousel: '=',
                    activeIaaContent: '=',
                },
                templateUrl: function () {
                    if (
                        !$config.isPreviewMode() &&
                        isCMS &&
                        !$config.isPDFMode()
                    ) {
                        return '/views/ib/components/GridColDirectiveCMS.html';
                    }
                    return '/views/ib/components/GridColDirective.html';
                },
                controller: [
                    '$scope',
                    '$signals',
                    '$timeout',
                    '$routeParams',
                    'SheetStructureHelperService',
                    '$uibModal',
                    'CMSSortableService',
                    'TaskCountdownService',
                    'CopyContainerHelperService',
                    '$element',
                    'CryptoHelperService',
                    'TaskDataService',
                    '$config',
                    '$bridges',
                    GridColController,
                ],
            };
        },
    ]);
}

